import { config } from './config';
import { tokens } from './tokens';
import axios from 'axios';
import { err, ok } from 'neverthrow';
export const reset = (() => {
    async function request(id) {
        try {
            const result = await axios.post(`${baseUrl()}/request`, {
                id,
            });
            if (result && result.status === 200) {
                return ok(true);
            }
            return err(result.data);
        }
        catch (error) {
            return err(error.response.data);
        }
    }
    async function confirm(token, password) {
        try {
            const _axios = axios.create();
            const result = await _axios.post(`${baseUrl()}/confirm`, { password }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (result && result.status === 200) {
                return ok(tokens.set(result.headers));
            }
            return err(result.data);
        }
        catch (error) {
            return err(error.response.data);
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/loginlink`;
    }
    return {
        request: request,
        confirm: confirm,
    };
})();
